package com.milta.core.localization

/**
 * Strings for the Photo/PDF/Excel import flow — analysis, result review, retry (DOM-02, `ImportScreen`).
 */
data class ImportsStrings(
    val titlePhoto: String,
    val titlePdf: String,
    val titleSpreadsheet: String,
    val fileSentSuffix: String,
    val fileWaitingConnectionLabel: String,
    // ── Écran A — analyse en cours ──
    val analysingTitle: String,
    val analysingSubtitle: String,
    /** MIL-26 — same "Analyse en cours" visual as [analysingSubtitle], mentions Claude Haiku (native PDF text or visual OCR on a scan). */
    val analysingSubtitlePdf: String,
    val stepFileSent: String,
    val stepExtracting: String,
    val stepReview: String,
    // ── Écran B — import réussi ──
    val successTitle: String,
    val successSubtitle: String,
    val addToRouteButton: String,
    val scanAnotherButton: String,
    // ── Écran C — informations incomplètes ──
    val partialTitle: String,
    val partialSubtitle: String,
    val missingFieldPlaceholder: String,
    val partialBannerText: String,
    val retryFileButton: String,
    val validateAndContinueButton: String,
    val attemptLabel: String,
    // ── Écran D — échec, nouvelle tentative possible ──
    val errorTitleUnreadable: String,
    val errorTitleMissingFields: String,
    val errorTitleNetworkError: String,
    val errorTitleGeneric: String,
    val errorSubtitle: String,
    val errorBannerSuffixUnreadable: String,
    val errorBannerSuffixMissingFields: String,
    val errorBannerSuffixNetworkError: String,
    val errorBannerSuffixGeneric: String,
    val retryWithNewFileButton: String,
    val manualEntryButton: String,
    val attemptsRemainingNote: String,
    // ── Écran E — nombre maximal de tentatives atteint ──
    val maxAttemptsTitle: String,
    val maxAttemptsSubtitle: String,
    val maxAttemptsBanner: String,
    val retryUnavailableButton: String,
    val newDocumentButton: String,
    // ── Écran F — service d'analyse indisponible (503) ──
    val serviceUnavailableTitle: String,
    val serviceUnavailableSubtitle: String,
    val serviceUnavailableBanner: String,
    // ── Écran G — hors ligne ──
    val offlineTitle: String,
    val offlineSubtitle: String,
    val offlineBanner: String,
    val retryOfflineButton: String,
    // ── 400 UnsupportedImportFormatException (pas d'écran dédié — réutilise le bandeau de l'écran D) ──
    val unsupportedFormatBanner: String,
    // ── MIL-26 — POST /imports/pdf : écran 15 (titre) et rejets 400 avant envoi ──
    /** Navbar title of écran 15 ("Vérifier les livraisons") — distinct from [com.milta.core.localization.OcrScanStrings.reviewTitle] ("Vérifier les données") even though the rest of the screen's vocabulary is factored onto [com.milta.core.localization.OcrScanStrings] per the mockup's own note. */
    val validationTitle: String,
    val fileRejectedTitle: String,
    val fileRejectedSubtitle: String,
    val bannerFileRequired: String,
    val bannerInvalidPdfFormat: String,
    val bannerFileTooLarge: String,
    val chooseAnotherFileButton: String,
)
